module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Logs', {
    attrs: {
      "showForm": _vm.showLogs,
      "formData": _vm.formData
    }
  }), _vm._v(" "), _c('div', [(!_vm.layout && !_vm.avulso) ? _c('p', [_c('ed-alert', {
    attrs: {
      "title": "Atenção"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n          Para visualizar a documentação do eSocial favor acessar o link\n          "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/document/d/e/2PACX-1vSBgbysNalUj6JJ9QpfYQGAU1w34wBgbXkN888R4b5jI1KbwgjQGRWEiMOVlbdpX4HKHAuPWE77ivY9/pub"
    }
  }, [_vm._v("\n            visualizar documentação\n          ")])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.avulso) ? _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.layoutItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })]) : _vm._e(), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tabConfig),
      callback: function($$v) {
        _vm.tabConfig = $$v
      },
      expression: "tabConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-geral"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Consultar Arquivos Disponíveis\n        ")]), _vm._v(" "), (!this.layout && _vm.formData.esocial_tabela && _vm.formData.esocial_tabela.descricao) ? _c('ed-alert', {
    staticClass: "mb-2 mt-2",
    attrs: {
      "title": "Atenção",
      "type": "warning"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n              " + _vm._s(_vm.formData.esocial_tabela.descricao) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('ed-table', {
    attrs: {
      "onSearch": _vm.getEsocial,
      "onRegister": _vm.avulso ? _vm.onRegister : null,
      "onEdit": _vm.avulso ? _vm.onEditXml : null,
      "onClear": _vm.onClear,
      "onFilter": _vm.getEsocial,
      "tableHead": _vm.tableHead,
      "tableData": _vm.tableData,
      "loadingTable": _vm.config.loading.table,
      "pagination": _vm.pagination,
      "response": _vm.response,
      "filterBadge": _vm.filterBadge,
      "registerName": "Inserir novo XML"
    }
  }, [_c('div', {
    attrs: {
      "slot": "table-filter-content"
    },
    slot: "table-filter-content"
  }, [_c('Filters', {
    attrs: {
      "parent": this
    }
  })], 1)]), _vm._v(" "), (_vm.avulso) ? _c('s0000', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2210'
  ) ? _c('s2210', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2220'
  ) ? _c('s2220', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-2240'
  ) ? _c('s2240', {
    attrs: {
      "parent": this
    }
  }) : (
    !_vm.config.loading.table &&
    _vm.formData.layout &&
    _vm.formData.layout == 'S-3000'
  ) ? _c('s3000', {
    attrs: {
      "parent": this
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('ed-modal', {
    attrs: {
      "title": 'Atualizar dados do evento',
      "modal": _vm.showModalUid,
      "width": "40%",
      "onSave": _vm.saveUid,
      "isModal": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": {
        novoUid: _vm.novoUid
      }
    }
  }, [_c('ed-alert', {
    staticClass: "px-3 mt-2",
    attrs: {
      "title": "Atenção",
      "type": "warning"
    }
  }, [_c('p', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_vm._v("\n            Se o campo recibo for preenchido ou atualizado, o sistema alterará o status para \"Processado com sucesso\". Caso fique vazio, ele não altera o status atual do evento.\n          ")])]), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Atualizar UID",
      "name": "novoUid",
      "required": ""
    },
    model: {
      value: (_vm.novoUid),
      callback: function($$v) {
        _vm.novoUid = $$v
      },
      expression: "novoUid"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Adicionar/atualizar recibo",
      "name": "novoRecibo",
      "required": ""
    },
    model: {
      value: (_vm.novoRecibo),
      callback: function($$v) {
        _vm.novoRecibo = $$v
      },
      expression: "novoRecibo"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33efc7d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/index.vue
// module id = 1441
// module chunks = 45